import styled from "styled-components";

export const ConnectWalletMain = styled.div`
  width: 430px;
  max-width: 100%;
  margin: 90px auto;
  padding: 40px;
  background: ${(props) => props.theme.body};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  @media (max-width: 767.98px) {
    padding: 15px;
  }

  & img {
    max-width: 130px;
    margin: 0 auto;
  }
  & h4 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 126.2%;
    text-align: center;
    color: ${(props) => props.theme.textColor};
    margin: 15px 0;
    @media (max-width: 767.98px) {
      font-size: 24px;
    }
  }
  & h6 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 145.7%;
    text-align: center;
    color: #555555;
    color: ${(props) => props.theme.subtitleColor};
    margin-bottom: 10px;
  }
  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 145.7%;
    text-align: center;
    color: ${(props) => props.theme.subtitleColor};
    & a {
      color: #0088cc;
    }
  }
`;
